import Vue from 'vue'
import VueI18n from 'vue-i18n'
// import { i18n } from 'vue-lang-router';

Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = require.context('../lang', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}
const numberFormats = {
  'en': {
    currency: {
      style: 'currency',
      currency: 'USD',
      currencyDisplay: 'symbol',
    }
  },
  'es-PE': {
    // currency: {
    //   style: 'currency',
    //   currency: 'EUR'
    // }
    currency: {
      style: 'currency',
      currency: 'PEN',
      symbol: 'S./',
      currencyDisplay: 'symbol',

    }
  },
  'PEN': {
    // currency: {
    //   style: 'currency',
    //   currency: 'EUR'
    // }
    currency: {
      style: 'currency',
      currency: 'PEN',
      symbol: 'S./',
      currencyDisplay: 'symbol',

    }
  },
  'pt': {
    currency: {
      style: 'currency',
      currency: 'BRL',
      currencyDisplay: 'symbol'
    }
  }
}

export default new VueI18n({
  locale: 'pt' || process.env.VUE_APP_I18N_LOCALE,
  fallbackLocale: 'pt' || process.env.VUE_APP_I18N_FALLBACK_LOCALE,
  messages: loadLocaleMessages(),
  numberFormats
})
